<template>

  <div class="container">

    <nav aria-label="breadcrumb" class="mb-4 extra-small">
      <ol class="breadcrumb bg-white fw-bold">
        <li class="breadcrumb-item"><router-link-locale :to="{name: 'home'}">{{$t('Inici')}}</router-link-locale></li>
        <li class="breadcrumb-item">{{$t('Materials')}}</li>
        <li v-if="response.material" class="breadcrumb-item active" aria-current="page">{{ response.material.activitat_titol }}</li>
      </ol>
    </nav>

    <h1 v-if="response.material">{{response.material.activitat_titol}}</h1>

    <div class="row">

      <div class="col-sm-12 col-md-12">

        <div class="card rounded-0" v-if="response.material">

          <div class="card-body">

            <div class="m-t-20 row">

              <div class="col-md-12">

                <div>

                  <div class="row mb-2" v-if="response.material.activitat_professors">
                    <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('autors')}}</p></div>
                    <div class="col-md-9 col-xs-12">
                      <div v-for="(professor, index) in response.material.activitat_professors" :key="professor">
                        <div v-if="professor.indexOf('##') === -1 || professor.split('##')[1] === ''">
                          <div class="mb-2">{{professor.split("##")[0]}} ({{$t(response.material.activitat_professors_roles[index])}})</div>
                        </div>
                        <div v-else>
                          <router-link :to="{name: 'professor', params: {id: professor.split('##')[1]}}">
                            <div class="mb-2">{{professor.split("##")[0]}} ({{$t(response.material.activitat_professors_roles[index])}})</div>
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row mb-2" v-if="response.material.activitat_organizador">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Organitzador')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <p class="mb-1">{{response.material.activitat_organizador}}</p>
                  </div>
                </div>

                <hr>

                <div class="row mb-2">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('tipus document')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <p class="mb-1">{{$t(response.material.activitat_subtipus_formacio)}}</p>
                  </div>
                </div>

                <div class="row mb-2" v-if="response.material.activitat_tipus">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('tipus formacio')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <p class="mb-1">{{response.material.activitat_tipus}}</p>
                  </div>
                </div>

                <div class="row mb-2" v-if="response.material.activitat_text_tipus">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('tipus formacio')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <p class="mb-1">{{response.material.activitat_text_tipus}}</p>
                  </div>
                </div>


                <div v-if="response.material.activitat_data_publicacio">
                  <div class="row mb-2">
                    <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Data Publicació')}}</p></div>
                    <div class="col-md-9 col-xs-12">
                      <p class="mb-1">{{response.material.activitat_data_publicacio}}</p>
                    </div>
                  </div>
                </div>
                <div v-else>

                  <div v-if="response.material.activitat_data_inicio || response.material.activitat_data_fin">
                    <div class="row mb-2" v-if="response.material.activitat_data_inicio">
                      <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Data d\'inici')}}</p></div>
                      <div class="col-md-9 col-xs-12">
                        <p class="mb-1">{{response.material.activitat_data_inicio}}</p>
                      </div>
                    </div>

                    <div class="row mb-2" v-if="response.material.activitat_data_fin">
                      <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Data de fi')}}</p></div>
                      <div class="col-md-9 col-xs-12">
                        <p class="mb-1">{{response.material.activitat_data_fin}}</p>
                      </div>
                    </div>
                  </div>

                  <div v-else>
                    <div class="row mb-2">
                      <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Data (any)')}}</p></div>
                      <div class="col-md-9 col-xs-12">
                        <p class="mb-1">{{response.material.data}}</p>
                      </div>
                    </div>
                  </div>

                </div>

                <div class="row mb-2" v-if="response.material.activitat_formacio_centre">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Formacio')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <p class="mb-1">{{response.material.activitat_formacio_centre}}</p>
                  </div>
                </div>

                <hr v-if="response.material.activitat_grups">

                <div class="row mb-1" v-if="response.material.activitat_grups">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Grups de recerca')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <div v-for="grup in response.material.activitat_grups" v-bind:key="grup">
                      <div class="mb-1"><router-link :to="{name: 'organitzacio', params: {id: grup}}">{{$t(grup)}}</router-link></div>
                    </div>
                  </div>
                </div>


              </div>

            </div>

          </div>

          <div class="card-footer">

              <div class="mt-1 mb-1 d-flex">
                <div class="d-flex ms-auto align-items-center">

                  <template v-if="response.material.id.startsWith('2099_') || response.material.id.startsWith('2117_')">
                    <img src="../../assets/images/mini-upc.svg" width="20" alt="UPCommons" class="me-1 d-none d-lg-block img-fluid">
                    <a class="me-4 d-none d-lg-block" :href="'http://hdl.handle.net/' + response.material.id.replace('_','/')" target="_blank" rel="noreferrer noopener">UPCommons <i class="fa-solid fa-external-link mini-icon"></i></a>
                  </template>
                  <template v-else>
                    <span class="me-4 d-none d-lg-block">&nbsp;</span>
                  </template>

                </div>
              </div>
          </div>

        </div>

      </div>

    </div>

    <h2 class="fw-bold mt-5">{{$t('participants')}}</h2>

    <div class="row" v-if="response.material">
      <div class="col-sm-12 col-md-12 mt-2 mx-3">
          <div v-for="(professor, index) in response.material.activitat_professors" :key="professor">
            <div v-if="professor.indexOf('##') === -1 ||professor.split('##')[1] === ''">
                <i class="fa-regular fa-user text-secondary fa-lg mb-4"></i> {{professor.split("##")[0]}} ({{$t(material.activitat_professors_roles[index])}})
            </div>
            <div v-else>
              <router-link :to="{name: 'professor', params: {id: professor.split('##')[1]}}">
                  <i class="fa-regular fa-user fa-lg mb-4"></i>
                  {{professor.split("##")[0]}} ({{$t(response.material.activitat_professors_roles[index])}})
              </router-link>
            </div>
          </div>
      </div>
    </div>

  </div>

</template>

<script>

import {computed, onMounted, ref} from "vue";
import {useRoute} from "vue-router";
import RouterLinkLocale from "@/components/RouterLinkLocale.vue";
import store from "@/store";
import MaterialService from "@/services/MaterialService";
import {imageUrlAlt} from "@/utils/utils";


  export default {
    name: "ActivitatFormacioView",
    methods: {imageUrlAlt},
    components: {RouterLinkLocale},

    setup() {
      const response = ref([]);
      const responseMaterials = ref([]);
      const route = useRoute();

      const totalElements = ref(0)
      const pageSize = computed(() => { return store.getters.pageSize})
      const selectedOrder = ref("data desc, activitat_data_available desc");

      onMounted(async () => {
        const id = route.params.id;
        response.value = await MaterialService.getMaterial(id)
        await store.dispatch('updateBackgroundImage', { view: route.name, url: require('@/assets/images/sections/banner-brown.webp') });
      });

      return {
        response,
        responseMaterials,

        selectedOrder,
        totalElements,
        pageSize
      }
    }
  }

</script>

<style scoped>
.card-body {
  position: relative;
  padding: 1.5rem; /* Optional: Adjust padding */
  color: #636363;
}

.card-body::before {
  content: "";
  position: absolute;
  top: 15px; /* Add margin from the top */
  right: 15px; /* Add margin from the right */
  bottom: 15px; /* Add margin from the bottom */
  left: auto; /* Add margin from the left */
  width: calc(50% - 25px); /* Occupies half of the card body minus the margins */
  height: calc(100% - 25px); /* Occupies full height minus the margins */
  background: url('../../assets/images/fons_fitxa.png') no-repeat right center; /* Aligns background image to the right */
  background-size: contain;
  opacity: 0.8; /* Adjust the transparency as needed */
  z-index: 1;
}

.card-body * {
  position: relative;
  z-index: 2;
}

</style>
